/**
 * Teams-related GraphQL mutations
 */

// Create a new team
export const CREATE_TEAM_MUTATION = `
  mutation CreateTeam($name: String!, $description: String, $group_id: Int, $company_id: Int!, $team_manager_id: Int) {
    insert_teams_one(object: {
      name: $name,
      description: $description,
      group_id: $group_id,
      company_id: $company_id,
      team_manager_id: $team_manager_id
    }) {
      id
      name
      description
      group_id
      company_id
      team_manager_id
      created_at
      updated_at
    }
  }
`;

// Update an existing team
export const UPDATE_TEAM_MUTATION = `
  mutation UpdateTeam($id: Int!, $name: String!, $description: String, $group_id: Int, $company_id: Int, $team_manager_id: Int) {
    update_teams_by_pk(pk_columns: { id: $id }, _set: {
      name: $name,
      description: $description,
      group_id: $group_id,
      company_id: $company_id,
      team_manager_id: $team_manager_id
    }) {
      id
      name
      description
      group_id
      company_id
      team_manager_id
      created_at
      updated_at
    }
  }
`;

// Delete a team
export const DELETE_TEAM_MUTATION = `
  mutation DeleteTeam($id: Int!) {
    delete_teams_by_pk(id: $id) {
      id
      name
    }
  }
`; 